import { render, staticRenderFns } from "./NotifyManage.vue?vue&type=template&id=89b6451e"
import script from "./NotifyManage.vue?vue&type=script&lang=js"
export * from "./NotifyManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports